import { gql } from '@apollo/client'
import PropTypes from 'prop-types'

const publicUserListingSeller = gql`
  fragment publicUserListingSeller on PublicUser {
    id
    firstname
    lastname
    avatar
    avatarBig
    city
    isPhoneVerified
    successfullySoldCount
    facebookAccount {
      friendsCount
    }
  }
`

export default publicUserListingSeller

export const publicUserListingSellerPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  firstname: PropTypes.string,
  lastname: PropTypes.string,
  avatar: PropTypes.string,
  avatarBig: PropTypes.string,
  city: PropTypes.string,
  isPhoneVerified: PropTypes.bool.isRequired,
  successfullySoldCount: PropTypes.number.isRequired,
  facebookAccount: PropTypes.shape({
    friendsCount: PropTypes.number.isRequired,
  }),
})
